import React from 'react';
import { TopBarSkeleton } from '@ldp-web/component-library/ui/molecules/top-bar';
import { MastHeadMainBarSkeleton } from '@ldp-web/component-library/ui/molecules/masthead-main-bar';
import { LogoProps } from '@ldp-web/component-library/ui/molecules/masthead-main-bar/masthead-main-bar-types';

/**
 * Logo shape from SDM header configuration. Passed into MastheadSkeletonSSR
 * and forwarded to the library's MastHeadMainBarSkeleton (as LogoProps).
 */
export interface LogoData {
  largeLogo?: {
    url?: string;
    altText?: string;
    height?: number;
    width?: number;
  };
  callToAction?: {
    url?: string;
  };
}

export interface MastheadSkeletonSSRProps {
  /** Background color for the top bar (from SDM theme) */
  topBarBgColor?: string;
  /** Logo data from SDM header configuration */
  logo?: LogoData;
}

/**
 * Masthead skeleton shown until the real masthead is ready (e.g. in MastheadSSRWrapper).
 * Composes skeletons from @ldp-web/component-library (TopBarSkeleton, MastHeadMainBarSkeleton)
 * so the placeholder matches the real masthead and avoids layout shift on hydration.
 * LogoData is the local type used to pass header logo config into the library's main bar skeleton.
 */
export const MastheadSkeletonSSR = ({
  topBarBgColor = '#c8102e',
  logo,
}: MastheadSkeletonSSRProps) => {
  return (
    <div data-testid="masthead-skeleton-ssr">
      <TopBarSkeleton containerBgColor={topBarBgColor} />
      <MastHeadMainBarSkeleton logo={logo as LogoProps} />
    </div>
  );
};

MastheadSkeletonSSR.displayName = 'MastheadSkeletonSSR';
